import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-61af4342"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-container" }
const _hoisted_2 = { class: "question-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_4 = { class: "response-container" }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': _ctx.form_item_order === 0 && _ctx.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "rate-img"
        }, [
          _createElementVNode("img", {
            src: image.currentSrc,
            onClick: ($event: any) => (_ctx.handleImageClick(index)),
            alt: "Face image"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getFaceLabel(index + 1)), 1)
        ]))
      }), 128))
    ])
  ], 2))
}